import React from 'react';

export default function ContentHtml({ html, className}) {
  if (!html) return null;
  return <div className={className} dangerouslySetInnerHTML={{__html: html}} />
}

//not sure if we are using it  - check later 